import { PairingMark } from './PairingMark';
import styles from './brand.module.css';

/** The "pairing / BY DENAMICO" lockup. `tone="light"` is for navy grounds. */
export function Wordmark({ tone = 'dark', size = 28 }: { tone?: 'dark' | 'light'; size?: number }) {
  return (
    <span className={`${styles.lockup} ${tone === 'light' ? styles.light : ''}`} style={{ ['--wm-size' as string]: `${size}px` }}>
      <PairingMark variant={tone === 'light' ? 'dark' : 'light'} height={Math.round(size * 1.25)} decorative />
      <span className={styles.words}>
        <span className={styles.name}>pairing</span>
        <span className={styles.by}>by Denamico</span>
      </span>
    </span>
  );
}
